import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { SwModalframeComponent } from '../../basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { SwTreeComponent } from '../../basic-components/sw-tree/sw-tree.component';

@Component({
  selector: 'app-sw-all-user-grid-modal',
  templateUrl: './sw-all-user-grid-modal.component.html',
  styleUrls: ['./sw-all-user-grid-modal.component.css']
})
export class SwAllUserGridModalComponent implements OnInit {

  /**
   * 动态创建组件传入的参数, 要含有 userId 这个数组
   */
  @Input() param

  /**
   * 动态创建组件的抛出事件
   */
  @Output() callback = new EventEmitter();

  /**
   * 模态框
   * @ignore
   */
  @ViewChild('userModal') userModal: SwModalframeComponent;

  /**
   * 是否展示左侧菜单
   * @ignore
   */
  showLeft: boolean = true

  /**
   * 左侧的筛选条件,可以使组织,岗位或角色
   * @ignore
   */
  filter: string = "department"

  /**
   * 查询条件
   * @ignore
   */
  selectData: any = {};

  /**
   * 模态框标题，默认是 "审批人区域"
   * @ignore
   */
  headerLogo: string = "审批人区域"

  asyncNodeUrl = environment.seekerWebAPI + "organize/queryTreeNode"; //请求路径 左侧树异步加载

  listGender = [{ id: 1, text: "男" }, { id: 0, text: "女" }];  //性别
  list1 = [{ id: false, text: "包含子级用户" }, { id: true, text: "不包含子级用户" }];  //是否级联下拉数据

  grid: any = []; //数据表格
  pageBase: any = {
    orderBy: null  //分页数组
  }
  checkedData: any = {}; //选中数据
  isLoading: boolean = false;
  orgPosId; //默认的组织或岗位Id
  showPos: boolean = true; //是否显示岗位
  orgPosType = null;//关联类型 
  displayName: string  //双向绑定的查询条件
  loginName: string  //双向绑定的查询条件
  lazy = true;//是否级联查询,默认为true

  @ViewChild("tree") tree: SwTreeComponent;

  constructor(
    private systemId: SystemIdService,
    private service: BdpService, //请求服务
    private el: ElementRef,
    private renderer2: Renderer2,
    private box: SwMassageBoxService,  //消息提示服务
  ) { }

  ngOnInit() {
    if (this.param.headerLogo) {
      this.headerLogo = this.param.headerLogo
    }
    //获取所有用户
    this.location()
  }
  //所有user-无关组织岗位
  location() {
    this.isLoading = true;
    let orderByStr = this.pageBase.orderBy; //排序
    this.selectData.systemId = this.systemId.getSystemId();
    //this.selectData.lazy = true;
    if (this.orgPosId == null) { //如果不关联查询
      let param = { "param": { pageNum: this.pageBase.current, pageSize: this.pageBase.size, orderBy: this.pageBase.orderBy, systemId: this.systemId.getSystemId(), isAdminQuery: true }, "entity": this.selectData }
      this.service.getUserService().queryUserPageList(param).subscribe(  //查询用户
        data => {
          this.isLoading = false;
          if (data["code"] == 200) {
            this.grid = data["data"]["records"];
            this.pageBase = data["data"];
            this.pageBase.orderBy = orderByStr;
          }
        }
      )
    } else {  //如果关联查询
      this.isLoading = false;
      this.selectByOrgPos()
    }
  }

  //是否显示岗位变化后初始化左侧树
  changeClick(event) {
    this.showPos = event.target.checked;
    this.tree.ngOnInit();
  }

  //根据组织岗位查user
  selectByOrgPos() {
    let Params;
    let orderByStr = this.pageBase.orderBy;
    let response;
    this.selectData.systemId = this.systemId.getSystemId();//拿系统id
    // this.selectData.lazy = false;//拿系统id
    if (this.orgPosType) {//岗位
      Params = { "param": { pageNum: this.pageBase.current, pageSize: this.pageBase.size, orderBy: this.pageBase.orderBy, systemId: this.systemId.getSystemId() }, "positionId": this.orgPosId, "entity": this.selectData }
      response = this.service.getUserService().queryUserByPositionId(Params)
    } else {//组织
      Params = { "param": { pageNum: this.pageBase.current, pageSize: this.pageBase.size, orderBy: this.pageBase.orderBy, systemId: this.systemId.getSystemId() }, lazy: this.lazy, "organizeId": this.orgPosId, "entity": this.selectData }
      response = this.service.getCommonService().queryUserByOrganizeId(Params)
    }
    response.subscribe(data => {
      if (data["code"] == 200) {
        this.grid = data["data"]["records"];
        this.pageBase = data["data"];
        this.pageBase.orderBy = orderByStr;
      }
    })
  }

  //查询
  clickSelect() {
    if (this.orgPosId != null) {  //如果是关联查询
      // this.hasRelated = true
      this.selectData.displayName = this.displayName
      this.selectData.loginName = this.loginName
      this.location();
    } else {//不关联查询
      //this.hasRelated = false
      this.selectData.displayName = this.displayName
      this.selectData.loginName = this.loginName
      this.pageBase.current = 1;
      this.checkedData = {};
      this.location();
    }
  }

  //重置
  clickreload() {
    this.displayName = ""
    this.loginName = ""
    this.selectData = {};
    this.checkedData = {};
    this.lazy = true;//新增后回调要初始化这个参数,左侧树初始化了,但是仍然存在激活的样式 
    this.orgPosId = null; //重置的时候将选择组织或者岗位初始化
    this.orgPosType = null
    let spans = this.el.nativeElement.querySelectorAll('span')
    spans.forEach(element => {
      this.renderer2.removeClass(element, 'tree-selected')  //左侧选中样式全都清空
    });
    this.pageBase = { current: 1, size: 10 };
    this.location();
  }

  //点击
  outSelectData(event) {
    this.checkedData = event;
  }

  //发生变化时触发
  clickPageQuery(event) {
    this.pageBase = event;
    if (this.orgPosId != null) {
      this.selectByOrgPos();
    } else {//关联查询
      this.checkedData = {};
      this.location();
    }
  }

  //树点击
  onVotedS(event) {
    this.pageBase = { current: 1, size: 10 };
    this.checkedData = undefined;
    this.orgPosId = event.key;
    //this.isOrgPos = true;//点击数 右边用户变带关联查询
    let orderByStr = this.pageBase.orderBy;
    if (event.data != null && event.data.type != "" && event.data.type == 2) {//点击岗位
      this.orgPosType = true;//类型改为岗位连接
      let param = { "param": { pageNum: this.pageBase.current, pageSize: this.pageBase.size, orderBy: this.pageBase.orderBy, systemId: this.systemId.getSystemId() }, "positionId": event.key, "entity": this.selectData }
      this.service.getUserService().queryUserByPositionId(param).subscribe(
        data => {
          if (data["code"] == 200) {
            this.grid = data["data"]["records"];
            this.pageBase = data["data"];
            this.pageBase.orderBy = orderByStr;
          }
        }
      )
    } else {   //点击组织
      this.orgPosType = false;//类型改为组织连接
      let param = { "param": { pageNum: this.pageBase.current, pageSize: this.pageBase.size, orderBy: this.pageBase.orderBy, systemId: this.systemId.getSystemId() }, "lazy": this.lazy, "organizeId": event.key, "entity": this.selectData }
      this.service.getCommonService().queryUserByOrganizeId(param).subscribe(
        data => {
          if (data["code"] == 200) {
            this.grid = data["data"]["records"];
            this.pageBase = data["data"];
            this.pageBase.orderBy = orderByStr;
          }
        }
      )
    }
  }

  //点击指定执行人模态框的确认按钮
  sureOperator() {
    if (this.checkedData && this.checkedData.displayName) {
      this.userModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
      this.callback.emit(this.checkedData)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
    } else {
      this.box.danger("请选择用户")
    }
  }

  //点击关闭模态框
  closeOperatorModal() {
    this.userModal.toggle() //关闭模态框
    this.callback.emit(false)  //抛出false, 只销毁组件,什么都不做
  }

  //隐藏左边面板
  showStyle(data) {
    this.showLeft = !data;
  }

  //展示性别中文数据
  getGender(id) {
    const tem1 = this.listGender.filter(item => item['id'] == id)
    if (tem1.length) {
      return tem1[0].text
    }
  }
}
